import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as matchingActions from "../../../../actions/matchingActions";

import * as modelHelper from "../../../../helpers/modelHelper";

import Modal from "../../../global/generic/Modal";
import Button, {BUTTON_SMALL} from "../../../global/generic/Button";
import SearchInput from "../../../global/generic/SearchInput";
import {INPUT_MEDIUM} from "../../../global/generic/Input";
import Table from "../../../global/generic/Table";
import CloseButton from "../../../global/generic/CloseButton";

const SELECT_AUTO = "selectAuto";
const SELECT_INCLUDE = "selectInclude";
const SELECT_EXCLUDE = "selectExclude";

const AUTO = "auto";
const INCLUDE = "include";
const EXCLUDE = "exclude";

class MatchingColorantsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchInput: ""
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSelectAutoClick(colorants) {
        if (colorants === SELECT_AUTO) {
            this.props.dispatchSelectColorantAction(
                this.props.tabId,
                this.props.activeColorants.filter(
                    (record) =>
                        !record.record.name.toUpperCase().includes(this.state.searchInput.toUpperCase()) &&
                        this.state.searchInput !== ""
                )
            );
        } else {
            if (this.props.activeColorants.find((colorant) => colorant.record === colorants)) {
                this.props.dispatchSelectColorantAction(
                    this.props.tabId,
                    this.props.activeColorants.filter((colorant) => colorant.record !== colorants)
                );
            }
        }
    }

    handleSelectColorantClick(colorants) {
        if ([SELECT_INCLUDE, SELECT_EXCLUDE].includes(colorants)) {
            this.props.dispatchSelectColorantAction(
                this.props.tabId,
                this.props.activeColorants
                    .filter(
                        (record) =>
                            !record.record.name.toUpperCase().includes(this.state.searchInput.toUpperCase()) &&
                            this.state.searchInput !== ""
                    )
                    .concat(
                        this.props.colorantList
                            .filter(
                                (record) =>
                                    record.name.toUpperCase().includes(this.state.searchInput.toUpperCase()) ||
                                    this.state.searchInput === ""
                            )
                            .map((record) => {
                                return {included: colorants === SELECT_INCLUDE, record};
                            })
                    )
            );
        } else {
            if (
                !this.props.activeColorants.find(
                    (colorant) => colorant.record === colorants.record && colorant.included === colorants.included
                )
            ) {
                this.props.dispatchSelectColorantAction(this.props.tabId, [
                    ...this.props.activeColorants.filter((colorant) => colorant.record !== colorants.record),
                    colorants
                ]);
            }
        }
    }

    handleClearInputClick = () => {
        this.setState({
            searchInput: ""
        });
    };

    handleSearchInputChange = (event) => {
        this.setState({
            searchInput: event.target.value
        });
    };

    getSubheader = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    size={BUTTON_SMALL}
                    label={<Translate value="matching.autoSelectAll" />}
                    onClick={() => {
                        this.handleSelectAutoClick(SELECT_AUTO);
                    }}
                />
                <Button
                    size={BUTTON_SMALL}
                    label={<Translate value="matching.includeAll" />}
                    onClick={() => {
                        this.handleSelectColorantClick(SELECT_INCLUDE);
                    }}
                />
                <Button
                    size={BUTTON_SMALL}
                    label={<Translate value="matching.excludeAll" />}
                    onClick={() => {
                        this.handleSelectColorantClick(SELECT_EXCLUDE);
                    }}
                />
                <SearchInput
                    className="primary-input margin-left-auto col-4"
                    size={INPUT_MEDIUM}
                    resetFilterClick={this.handleClearInputClick}
                    onChange={this.handleSearchInputChange}
                    value={this.state.searchInput}
                />
            </React.Fragment>,
            "flex flex-column-gap-10px"
        );
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.colorant" />),
            modelHelper.buildTableCell(<Translate value="matching.usedForMatching" />)
        ]);
    };

    isActive = (record) => {
        return this.props.activeColorants.find((colorant) => colorant.record === record)
            ? this.props.activeColorants.find((colorant) => colorant.record === record).included
                ? INCLUDE
                : EXCLUDE
            : AUTO;
    };

    getBackgroundColor = (record) => {
        return this.isActive(record) === AUTO
            ? "white"
            : this.isActive(record) === INCLUDE
              ? "var(--info-box-background-color-warning)"
              : "var(--info-box-background-color-error)";
    };

    getTableRows = () => {
        return this.props.colorantList
            .filter(
                (record) =>
                    record.name.toUpperCase().includes(this.state.searchInput.toUpperCase()) ||
                    this.state.searchInput === ""
            )
            .map((record) => {
                const rowData = [
                    modelHelper.buildTableCell(
                        <div>
                            <div className="color-square" style={{backgroundColor: record.rgb}}></div>
                            <span className="color-primary font-size-1_5em" style={{margin: "auto", marginLeft: "5px"}}>
                                {record.name}
                            </span>
                        </div>,
                        "flex margin-5",
                        undefined,
                        {style: {display: "flex", alignItems: "center"}}
                    ),
                    modelHelper.buildTableCell(
                        record.canMatch === undefined ? (
                            <React.Fragment>
                                <Button
                                    className={this.isActive(record) === AUTO ? "active" : ""}
                                    size={BUTTON_SMALL}
                                    label={<Translate value={"matching.auto"} />}
                                    onClick={() => {
                                        this.handleSelectAutoClick(record);
                                    }}
                                />
                                <Button
                                    className={this.isActive(record) === INCLUDE ? "active" : ""}
                                    size={BUTTON_SMALL}
                                    label={<Translate value={"matching.include"} />}
                                    onClick={() => {
                                        this.handleSelectColorantClick({included: true, record});
                                    }}
                                />
                                <Button
                                    className={this.isActive(record) === EXCLUDE ? "active" : ""}
                                    size={BUTTON_SMALL}
                                    label={<Translate value={"matching.exclude"} />}
                                    onClick={() => {
                                        this.handleSelectColorantClick({included: false, record});
                                    }}
                                />
                            </React.Fragment>
                        ) : (
                            <span className="font-size-1_25em">
                                {<Translate value={"matching.notAvailableForMatching"} />}
                            </span>
                        ),
                        "flex-column-gap-10px",
                        undefined,
                        {style: {display: "flex", justifyContent: "center"}}
                    )
                ];
                return modelHelper.buildTableRow(rowData, "", record.id, {
                    style: {height: "7vh", backgroundColor: this.getBackgroundColor(record)}
                });
            });
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-6"),
            modelHelper.buildTableColumn("col-6 vertical-center text-center ")
        ];
    };
    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Table
                    variant={"TABLE_VARIANT_PRIMARY"}
                    classname="flex-child"
                    tableHeader={this.getTableHeader()}
                    tableRows={this.getTableRows()}
                    tableColumns={this.getTableColumns()}
                />
            </React.Fragment>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(<CloseButton onClick={this.handleCloseModalClick} />);
    };
    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.colorants" />)}
                subHeader={this.getSubheader()}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    return {
        colorantList: store.matchingTab[ownProps.tabId].colorantList,
        activeColorants: store.matchingTab[ownProps.tabId].activeColorants
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MATCHING_COLORANTS_MODAL));
        },
        dispatchSelectColorantAction: (tabId, colorants) => {
            dispatch(matchingActions.setInclude(tabId, colorants));
        }
    };
};

export default MatchingColorantsModal = connect(mapStoreToProps, mapDispatchToProps)(MatchingColorantsModal);
